//WW-1163 PC_WW_1163_05-10 -Vishwa S
import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';
import swal from 'sweetalert';

//WW-1163 PC_WW_1163_11-27 -Vishwa S
const pageLoad = (interactivePageLoadObj) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.InteractiveDiagram,
            SDIConstants.methodNames.Interactive_PageLoad,
            JSON.stringify(interactivePageLoadObj),

            (data) => {
                if (data.success) {
                    //;
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.Interactive_PageLoad, response: data.response };
                        //;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

export {
    pageLoad
}